import { createApiDescription } from "../../helperFunctions";

export const documentRequestTemplateInfo = {
    documentRequestTemplate: createApiDescription(
        "Get all document request templates.",
        ["GET Document Request Templates API provides results based on the given filters on the request headers and if no filter values are given, it provides results based on default value mapped with all filters."]
    ),
}